import classes from './landingFeatures.module.scss'


export default function LandingFeatures() {
    return (
        <div className={classes.module}>
            <div className={classes.content}>
                <div className={classes.aiPowered}>
                    <img src="/images/ai-powered-smile-design.png" alt="AI-Powered Smile Design" />
                    <div className={classes.info}>
                        <div className={classes.title}>
                            <h4 className={classes.blue500}>AI-POWERED</h4>
                            <h4>Smile Design</h4>
                        </div>
                        <h6>Fast, Personalized, and Patient-Centered</h6>
                        <p>Tx-Genius uses patented AI to instantly design personalized smiles based on age, gender, and ethnicity, with patient feedback shaping the process for a faster, more predictable result than traditional methods.</p>
                    </div>
                </div>
 
                <div className={classes.cadDesign}>
                    <img src="/images/ai-driven-diagnosis.png" alt="3D CAD Design" />
                    <div className={classes.info}>
                        <div className={classes.title}>
                            <h4 className={classes.blue500}>3D CAD</h4>
                            <h4>Design</h4>
                        </div>
                        <h6>From Smile Design to Smile Reality</h6>
                        <p>Tx-Genius's patented algorithm transforms Smile Design into Smile Reality with speed, predictability, and a patient-focused approach. In cosmetic dentistry, patients can test 3D-printed veneers on the same day, enhancing treatment acceptance. In implant dentistry, permanent zirconia bridges are delivered within 48-72 hours post-surgery, slashing treatment time by months.</p>
                    </div>
                </div>

                <div className={classes.aiDiagnosis}>
                    <img src="/images/diagnosis.png" alt="AI-Driven Diagnosis" />
                    <div className={classes.info}>
                        <div className={classes.title}>
                            <h4>AI-Driven</h4>
                            <h4 className={classes.blue500}>Diagnosis</h4>
                        </div>
                        <h6>The Foundation of Predictable Treatment</h6>
                        <p>Tx-Genius's AI-driven platform ensures a precise diagnosis by analyzing a patient’s age, gender, and ethnicity. This thorough process helps clinicians create natural, harmonious smiles while preventing missed critical diagnoses, leading to predictable, patientcentered outcomes.</p>
                    </div>
                </div>

               <div className={classes.guessWork}>
                    <div className={classes.info}>
                        <div className={classes.title}>
                            <h4 className={classes.blue500}>Eliminate</h4>
                            <h4>Guesswork</h4>
                        </div>
                        <h6>Ensure Patient Approval at Every Step</h6>
                        <p>Tx-Genius ensures patient-approved veneers by involving them at every step with e-signature approvals. This eliminates uncertainty, reduces costly remakes, and delivers predictable results patients love.</p>
                    </div>
                    <img src="/images/cadDesign.png" alt="Eliminate Guesswork" />
                </div>

               <div className={classes.reasons}>
                    <h3>AI-Driven 3D Bridge Design & <br /> Implant Planning</h3>
                    <h6>Here’s a short summary of the new dental implant process</h6>
                    <div className={classes.items}>
                        <div className={classes.item}>
                            <div className={classes.header}>
                                <h6>Fast Result</h6>
                                <img width={56} height={56} src="/images/reasonIcon.png" alt="Reason Icon" />
                            </div>
                            <p>Permanent restorations delivered in 48-72 hours.</p>
                        </div>
                        <div className={classes.item}>
                            <div className={classes.header}>
                                <h6>No Fractures</h6>
                                <img width={56} height={56} src="/images/reasonIcon.png" alt="Reason Icon" />
                            </div>
                            <p>Eliminates provisional prosthesis fractures.</p>
                        </div>
                        <div className={classes.item}>
                            <div className={classes.header}>
                                <h6>Better Healing</h6>
                                <img width={56} height={56} src="/images/reasonIcon.png" alt="Reason Icon" />
                            </div>
                            <p>Uses biocompatible materials to promote tissue healing.</p>
                        </div>
                        <div className={classes.item}>
                            <div className={classes.header}>
                                <h6>Shorter Treatment</h6>
                                <img width={56} height={56} src="/images/reasonIcon.png" alt="Reason Icon" />
                            </div>
                            <p>Uses biocompatible materials to promote tissue healing.</p>
                        </div>
                        <div className={classes.item}>
                            <div className={classes.header}>
                                <h6>High Precision</h6>
                                <img width={56} height={56} src="/images/reasonIcon.png" alt="Reason Icon" />
                            </div>
                            <p>Maintains accuracy throughout the process.</p>
                        </div>

                    </div>
                    <h6>This innovative approach transforms dental implants by offering quicker, safer, and more precise outcomes for patients.</h6>
                </div>

                 <div className={classes.downloadCenter}>
                    <div className={classes.linkBox}>
                        <img src="/images/tx-genius-logo.png" alt='TXGENIUS' width={125} height={125} />
                        <img src="/images/tx-genius-text.png" alt='TXGENIUS' width={199} height={26} />
                        <span>Revolutionizing Dentistry with AI and 3D Precision</span>
                        <a href="https://apps.apple.com/ca/app/txgenius/id6670690402" target='_blank'>
                            <div className={classes.appleDownload}>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
